import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import fr from 'date-fns/locale/fr';
import React, { useState } from 'react';

import { dateFormat, dateToString, stringToDate } from '../../utils/date-utils';

interface DatePickerWrapperProps {
    label: string;
    value: string;
    onChange: (date: string) => void;
}

export const DatePickerWrapper: React.FC<DatePickerWrapperProps> = ({ label, value, onChange }) => {
    const [selectedDate, setSelectedDate] = useState<Date | null>(stringToDate(value));
    const [open, setOpen] = useState(false);

    const handleDateAccept = (date: Date | null) => {
        const formattedDate = dateToString(date);
        onChange(formattedDate);
        setOpen(false);
    };

    const handleDateChange = (date: Date | null) => {
        setSelectedDate(date);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
            <DatePicker
                open={open}
                label={label}
                format={dateFormat}
                value={selectedDate}
                onAccept={handleDateAccept}
                onChange={handleDateChange}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                slotProps={{
                    textField: { variant: 'standard', sx: { width: '100%' } },
                }}
            />
        </LocalizationProvider>
    );
};
